


















































































import {Component, Watch} from 'vue-property-decorator';
import Vue from 'vue';
import {Action, Getter} from 'vuex-class';
import {ActionTypes, GetterTypes} from '@/modules/neovehicle/store/types';
import {Brand, vehicleTypes} from '@/modules/neovehicle/models';
import {
  DncClientContractFilter,
  DncFamilyFilter, DncFamilyGroupFailsFilter, DncFamilyGroupFilter,
} from '@/modules/neovehicle/models/filters';
import {GET_COUNTRY_SELECTED} from '@/store/root';
import {CountryEnum} from '@/models/Enums';
import {
  DncClientContract,
  DncFamily,
  DncFamilyGroup,
  DncFamilyGroupFails,
  DncFamilyGroupFamily,
} from '@/modules/neovehicle/models/dnc';
import {DataTableDncEnum} from '@/modules/neovehicle/models/enums';
import DataTableDncFamily from '@/modules/neovehicle/components/datatable-dnc-family.component.vue';
import DataTableDncFamilyGroup from '@/modules/neovehicle/components/datatable-dnc-family-group.component.vue';
import BtnContentOptions from '@/modules/neovehicle/components/btn-content-options.component.vue';
import DialogClassificationDncFamily from '@/modules/neovehicle/components/dialog-classification-dnc-family.component.vue';
import DialogDncFamilyGroupCreate from '@/modules/neovehicle/components/dialog-dnc-family-group-create.component.vue';
import DialogDncFamilyGroupFails from '@/modules/neovehicle/components/dialog-dnc-family-group-fails.component.vue';

import {differenceBy, remove, uniq} from 'lodash';
import DialogFamilyCreate from '@/modules/neovehicle/components/dialog-family-create.component.vue';
import DataTableFamilyVersion from '@/modules/neovehicle/components/datatable-version.component.vue';

@Component({
  components: {
    DataTableFamilyVersion,
    DialogFamilyCreate,
    DialogClassificationDncFamily,
    DialogDncFamilyGroupCreate,
    DialogDncFamilyGroupFails,
    DataTableDncFamily,
    DataTableDncFamilyGroup,
    BtnContentOptions,
  },
})
export default class extends Vue {
  public isLoading = false;
  public vehicleTypes = vehicleTypes;
  public headers: any = [];

  @Getter(GET_COUNTRY_SELECTED)
  public countrySelected: CountryEnum;

  @Getter(GetterTypes.GET_DNC_FAMILIES)
  public dncFamilies: DncFamily[];

  @Getter(GetterTypes.GET_DNC_FAMILY_GROUPS)
  public dncFamilyGroups: DncFamilyGroup[];

  @Getter(GetterTypes.GET_BRANDS)
  public brands: Brand[];

  @Getter(GetterTypes.GET_DNC_CLIENT_CONTRACTS)
  public clients: DncClientContract[];

  @Getter(GetterTypes.GET_DNC_FAMILY_GROUP_FAILS)
  public dncFamilyGroupFails: DncFamilyGroupFails[];

  @Action(ActionTypes.FETCH_BRANDS)
  public fetchBrands: () => Promise<Brand[]>;

  @Action(ActionTypes.FETCH_DNC_FAMILY_GROUPS)
  public fetchDncFamilyGroups: (filter: DncFamilyGroupFilter) => Promise<DncFamilyGroup[]>;

  @Action(ActionTypes.FETCH_DNC_FAMILIES)
  public fetchDncFamilies: (filter: DncFamilyFilter) => Promise<DncFamily[]>;

  @Action(ActionTypes.FETCH_DNC_CLIENT_CONTRACTS)
  public fetchDncClientContracts: (filter: DncClientContractFilter) => Promise<DncClientContract[]>;

  @Action(ActionTypes.SAVE_DNC_FAMILY_GROUP_FAMILY)
  public saveDncFamilyGroupFamily: (payload: DncFamilyGroupFamily) => Promise<boolean>;

  @Action(ActionTypes.SAVE_DNC_FAMILY_GROUP)
  public saveDncFamilyGroup: (payload: DncFamilyGroup) => Promise<boolean>;

  @Action(ActionTypes.FETCH_DNC_FAMILY_GROUP_FAILS)
  public fetchDncFamilyGroupsFails: (filter: DncFamilyGroupFailsFilter) => Promise<DncFamilyGroupFails[]>;

  @Action(ActionTypes.FETCH_DNC_FAMILY_GROUPS_EXPORT)
  public fetchDncFamilyGroupsExport: (country: CountryEnum) => Promise<void>;

  @Action(ActionTypes.CLEAR_STORE)
  public clearStore: () => void;

  public dncFamilyFilter!: DncFamilyFilter;
  public dncFamilyGroupFilter!: DncFamilyGroupFilter;
  public dataTableDncEnum = DataTableDncEnum;

  public dncFamiliesSelected: DncFamily[] = [];
  public dncFamiliesAssociate: DncFamily[] = [];
  public dncFamilyGroupEdit: DncFamilyGroup | undefined;
  public isDncFamilyGroupFail: boolean = false;

  public vehicleTypesSearch = Object.keys(vehicleTypes).map((key: any) => ({
    id: key,
    name: vehicleTypes[key].name,
  }));

  public openDialogClassificationDncFamily: boolean = false;
  public openDialogDncFamilyGroupCreate: boolean = false;
  public openDialogDncFamilyGroupFails: boolean = false;

  @Watch('countrySelected')
  public changeCountry(selected: CountryEnum) {
    this.dncFamilyFilter.country = selected;
    this.dncFamilyGroupFilter.country = selected;
    this.loadFamilies();
  }

  public get isFilterButtonDisabled() {
    return this.dncFamiliesSelected.length > 0
        && this.dncFamiliesSelected.every((x) => x.brandname === this.dncFamiliesSelected[0].brandname);
  }

  public async changeClassified() {
    if (!this.isDncFamilyGroupFail) {
      await this.loadFamilies();
    }

    this.isDncFamilyGroupFail = false;
  }

  public async handleDownload() {
    this.isLoading = true;
    await this.fetchDncFamilyGroupsExport(this.countrySelected);
    this.isLoading = false;
  }

  public async loadFamilies() {
    this.isLoading = true;
    await this.fetchDncFamilies(this.dncFamilyFilter);
    this.isLoading = false;
  }

  public async created() {
    this.clearStore();

    this.dncFamilyFilter = {
      isClassified: false,
      country: this.countrySelected,
    };

    this.dncFamilyGroupFilter = {
      country: this.countrySelected,
    };

    this.fetchDncFamilyGroupsFails({ country: this.countrySelected });
    this.fetchDncClientContracts({ country: this.countrySelected });
    this.fetchBrands();
    await this.loadFamilies();
  }

  public async handleTab(dataTableDncEnum: DataTableDncEnum) {
    const fetch = {
      [DataTableDncEnum.DncFamily]: async () => await this.fetchDncFamilies(this.dncFamilyFilter),
      [DataTableDncEnum.DncFamilyGroup]: async () => await this.fetchDncFamilyGroups(this.dncFamilyGroupFilter),
    };

    this.isLoading = true;
    await fetch[dataTableDncEnum]();

    this.isLoading = false;
  }

  public handleSelectDncFamily(dncFamilySelected: DncFamily[]) {
    this.dncFamiliesSelected = this.getUniqSelected(this.dncFamiliesSelected, dncFamilySelected, 'idfamily');
  }

  public getUniqSelected(selected: any, data: any, key: string) {
    const removed = differenceBy(selected, data, key);
    let result = selected.concat(data);
    result = remove(result, (f: any) => !removed.some((m: any) => m[key] === f[key]));
    result = uniq(result);

    return result.filter((x: any) => !!x);
  }

  public async handleClassification(dncFamily: DncFamily) {
    this.openDialogClassificationDncFamily = !this.openDialogClassificationDncFamily;
    this.dncFamiliesAssociate = [dncFamily];
  }

  public async handleClassificationSelected() {
    this.openDialogClassificationDncFamily = !this.openDialogClassificationDncFamily;
  }

  public async handleClassificationSave(dncFamilyGroupFamily: DncFamilyGroupFamily[]) {
    for (const x of dncFamilyGroupFamily) {
      await this.saveDncFamilyGroupFamily(x);
    }
    this.fetchDncFamilyGroupsFails({ country: this.countrySelected });
    await this.loadFamilies();
    this.handleClassificationCancel();
  }

  public handleClassificationCancel() {
    this.openDialogClassificationDncFamily = false;
    this.dncFamiliesAssociate = [];
    this.resetSelectedModels();
  }

  public resetSelectedModels() {
    this.dncFamiliesSelected = [];
    (this.$refs.dataTableDncFamilies as any).resetSelect();
  }

  public handleDncFamilyGroupCreate() {
    this.openDialogDncFamilyGroupCreate = true;
  }

  public handleDncFamilyGroupEdit(dncFamilyGroup: DncFamilyGroup) {
    this.openDialogDncFamilyGroupCreate = true;
    this.dncFamilyGroupEdit = { ...dncFamilyGroup };
  }

  public async handleDncFamilyGroupSave(dncFamilyGroup: DncFamilyGroup) {
    await this.saveDncFamilyGroup({...dncFamilyGroup, country: this.countrySelected});
    await this.fetchDncFamilyGroups(this.dncFamilyGroupFilter);
    this.openDialogDncFamilyGroupCreate = false;
  }

  public handleDncFamilyGroupCancel() {
    this.openDialogDncFamilyGroupCreate = false;
    this.dncFamilyGroupEdit = undefined;
  }

  public handleDncFamilyGroupFailsCancel() {
    this.openDialogDncFamilyGroupFails = false;
    this.isDncFamilyGroupFail = false;
  }

  public async handleFamilyGroupsFails() {
    this.isDncFamilyGroupFail = true;
    this.openDialogDncFamilyGroupFails = true;
    await this.fetchDncFamilyGroupsFails({ country: this.countrySelected });
  }
}
